import {IntermediatePart} from "../../intermediatePart";
import {createParentPositions} from "../../constants";

export default class TowelTowelRing extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "towel_towel_ring";
    this.partName = "Towel";
    this.translateId = "visualizer.bathroom.accessories.towel";
    if (isChild) {
      createParentPositions(this);
    }
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const towelRing = this.getParent().towelRing;
    if (towelRing && towelRing.layerPositions && towelRing.activeFeature) {
      conditions.push({
        propName: "MatchingFeature",
        propValue: towelRing.activeFeature.getSplittedSku()
      });
    }
    return conditions
  }
}
